import React from 'react';
import './PrivacyPolicy.scss';
import PageLayout from '../../components/Layout/PageLayout.tsx';

const PrivacyPolicy: React.FC = () => {
  return (
    <PageLayout>
      <div className="banner">
        <h1 className="banner-heading">Privacy Policy</h1>
        <div className="banner-description">Read Medicare privacy policies and get the privacy forms you need.</div>
      </div>
      <div className="privacy-policy-body">
        <div className="privacy-policy-content">
          <p>Find The HealthSpring Healthcare privacy policies below.</p>
          <div>
            <a href="#">HealthSpring Healthcare Medicare Advantage Privacy Notice [PDF]</a>
          </div>
          <div>
            <a href="#">Website Privacy Notice [PDF]‡</a>
            <div>Learn about how we maintain your personal information on our websites.</div>
          </div>
          <div>
            <a href="#">myHealthSpring Mobile App Privacy Notice [PDF]‡</a>
            <div>Read about our privacy practices for the myHealthSpring mobile app.</div>
          </div>
          <div>
            <a href="#">Find the privacy forms you need</a>
          </div>
          <p>‡ Selecting these links will take you away from HealthSpring Healthcare Medicare plans.</p>
        </div>
      </div>
      <div className="privacy-policy-body-2">
        <div className="privacy-policy-columns">
          <div className="privacy-policy-column">
            <h6 className="privacy-policy-heading">Customer Plan Links</h6>
            <ul className="privacy-policy-links">
              <li>
                <a className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Choosing a Medicare Plan
                </a>
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="privacy-policy-link"
                >
                  Contact HealthSpring Healthcare
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Disaster Policy
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Eligibility and Enrollment
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Filing a Grievance
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Appeals Process
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Coverage Decisions and Exceptions
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Disenrollment
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Organization Determination
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Pre-Enrollment Disclaimers
                </a>
              </li>
            </ul>
          </div>

          {/* Audiences */}
          <div className="privacy-policy-column">
            <h6 className="privacy-policy-heading">Audiences</h6>
            <ul className="privacy-policy-links">
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Individuals and Families
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Employers
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Brokers
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Providers
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  About HealthSpring Healthcare
                </a>
              </li>
            </ul>
          </div>

          {/* Other HealthSpring Healthcare Websites */}
          <div className="privacy-policy-column">
            <h6 className="privacy-policy-heading">Other HealthSpring Healthcare Websites</h6>
            <ul className="privacy-policy-links">
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Group Medicare Plans for Employers
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Health Care Providers
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Pharmacy Resources
                </a>
              </li>
              <li>
                <a href="#" className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Pharmacy Residency Programs
                </a>
              </li>
            </ul>
          </div>

          {/* Medicare Links */}
          <div className="privacy-policy-column">
            <h5 className="privacy-policy-heading">Medicare Links</h5>
            <ul className="privacy-policy-links">
              <li>
                <a className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare.gov
                </a>
              </li>
              <li>
                <a className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Ombudsman
                </a>
              </li>
              <li>
                <a className="privacy-policy-link" target="_blank" rel="noopener noreferrer">
                  Medicare Complaint Form
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default PrivacyPolicy;
